<template>
<div class="monitor-container">
    <Row type="flex" :gutter="9">
        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <!--信号交互-->
            <div slot="title" class="card-title">ModbusRTU</div>
            <Row type="flex" class="normal-hover" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a180') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.OptRtuBaud"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in OptRtuBaudList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a181') }}</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.RtuAddr803" />                        
                    </Col>
                </Row>
                </Col>
            </Row>                    
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">ModbusTCP</div>
            <Row type="flex" class="normal-hover">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">IP</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.Ip0" />-
                        <InputNumber  size="small"  type="number" v-model="localData.Ip1" />-
                        <InputNumber  size="small"  type="number" v-model="localData.Ip2" />-
                        <InputNumber  size="small"  type="number" v-model="localData.Ip3" />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a182') }}</div>
                    </Col>
                    <Col flex="1" >
                       <InputNumber  size="small"  type="number" v-model="localData.Netmask0" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Netmask1" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Netmask2" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Netmask3" />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a183') }}</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.Gateway0" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Gateway1" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Gateway2" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Gateway3" />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">MAC</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.Mac0" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Mac1" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Mac2" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Mac3" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Mac4" />-
                       <InputNumber  size="small"  type="number" v-model="localData.Mac5" />
                    </Col>
                </Row>
                </Col>
            </Row>
            
        </Card>
        </Col>

    </Row>
    <Row>
        <Button type="primary" @click="handleSave">{{ getTranslation('c006') }}</Button>
    </Row>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import { int16toBit, bitToInt16 } from '@/util/util'


export default {
    name: 'CommunicationSetting',
    components: {},
    props: {
        systemData: {
            type: Object,
            default: function() { return {} }
        },
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 需要按位编辑的字段列表，后续新增字段只需追加到此数组
            bitFields: [],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
            // 需要本地副本的普通值字段（避免直接修改 prop），后续新增字段只需追加到此数组
            valueFields: ['OptRtuBaud','RtuAddr803','Ip0','Ip1','Ip2','Ip3',
            'Netmask0','Netmask1','Netmask2','Netmask3','Gateway0','Gateway1','Gateway2','Gateway3',
            'Mac0','Mac1','Mac2','Mac3','Mac4','Mac5'
         ],
            // 本地值副本 { HwValveTypePrePrs: val, hwValveTypeTrip: val }
            localData: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
       
        OptRtuBaudList(){
            return [
              "19200",
              "38400",
              "57600",
              "115200",
            ]
        }
        
    },
    created() {
        var self = this
        this.bitFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                if (newVal != null) {
                    self.$set(self.localBitsMap, field, int16toBit(newVal))
                    self.$set(self.originalData, field, newVal)
                }
            }, { immediate: true })
        })
        this.valueFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                self.$set(self.localData, field, newVal)
                self.$set(self.originalData, field, newVal)
            }, { immediate: true })
        })
    },
    methods: {
        handleSave() {
            var payload = {}
            var self = this
            this.bitFields.forEach(function(field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            this.valueFields.forEach(function(field) {
                var newVal = self.localData[field]
                if (newVal != null && newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            if (Object.keys(payload).length > 0) {
                this.$emit('save', payload)
            }else {
                 this.$Message.error(this.getTranslation('a159'))
            }
        }
    },
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');
.multi-row{
    margin-top:10px;
}

</style>
